// Battery-shaped SoC indicator — вигляд як батарейка УЗЕ на /ems (ems/page.tsx):
// контур var(--line-strong), заряд темовими токенами (--ok/--warn/--err).
// Внутрішній «трек» = var(--bg): SCADA-картка непрозора (--surface-solid,
// світліша за --bg), а /ems — скляна (майже --bg). Без треку напівпрозорий
// заряд@0.9 над світлішою панеллю виглядав яскравішим. Трек вирівнює фон під
// зарядом до --bg — тож на SCADA батарейка виглядає ІДЕНТИЧНО до /ems.
export default function BatteryViz({ soc, charging, fault, h = 168 }:
  { soc: number | null; charging?: boolean; fault?: boolean; h?: number }) {
  const s = soc == null ? 0 : Math.max(0, Math.min(100, soc));
  // (H − 12): рівномірний відступ заливки до контуру — по 6px з усіх боків
  // (ліво/право вже 6px через x=18/width=56; тут вирівнюємо верх/низ).
  const H = 132, W = 68, fillH = (H - 12) * (s / 100);
  const col = fault ? 'var(--err)' : (s < 40 ? 'var(--warn)' : 'var(--ok)');
  const w = Math.round(h * 92 / 168);
  return (
    <svg viewBox="0 0 92 168" width={w} height={h} style={{ flexShrink: 0, display: 'block' }}>
      <rect x="34" y="2" width="24" height="9" rx="2.5" fill="var(--line-strong)" />
      <rect x="12" y="12" width={W} height={H} rx="12" fill="var(--bg)" />
      <rect x="12" y="12" width={W} height={H} rx="12" fill="none" stroke="var(--line-strong)" strokeWidth="2.5" />
      <rect x="18" y={12 + (H - 6 - fillH)} width={W - 12} height={fillH} rx="7" fill={col} opacity={0.9}
        style={{ transition: 'y .7s ease, height .7s ease, fill .4s' }} />
      {charging && <path d="M50 56 L37 94 L47 94 L41 122 L59 82 L48 82 Z" fill="var(--text)" opacity={0.9} />}
    </svg>
  );
}
